import Vue from 'vue';
import VueI18n from 'vue-i18n';
import vi from './vi';
import en from './en';

Vue.use(VueI18n);

// Đồng bộ lưu trữ vùng ngôn ngữ với "user-locale" khớp với HeaderNavBar.vue
const savedLocale = localStorage.getItem('user-locale') || 'vi';

export const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'vi', // Ngôn ngữ dự phòng khi thiếu từ khóa tương ứng
  messages: {
    vi,
    en
  }
});

export default i18n;
